<template>
 <div class="zj-camera-player is-preview">
   <div ref="player" @dblclick.stop="onDblClick"></div>
   <div ref="imgdiv"></div>
 </div>
</template>
<script>
import ZJPlayer from '../../player';
export default {
  name: 'ZjCameraPreview',
  props: {
      cameraId: String,
      cameraName: String, 
      /*
      缩放模式: 
        0 - 不缩放;。
        1 - 保持宽高比进行缩放，选择尺寸较大的缩放比率。
        2 - 保持宽高比进行缩放，选择尺寸较小的缩放比率。
      */
      scaleMode: {
        type: Number,
        default: 1
      },

      /*
      是否启用字节对齐: 
        0 - 不启用;。
        1 - 启用。
      */
      align: {
        type: Number,
        default: 0
      },

      /**
      码流类型：(默认为 1)
        0 - 主码流。
        1 - 子码流。
        2 - 第三码流。
       */
      streamType: {
        type: Number,
        default: 1
      },

      /**
      压缩方式：
        0 - 不压缩。
        1 - Deflate。
        2 - h264。
       */
      zipMethod: {
        type: Number,
        default: 2
      },

      autoplay: Boolean
  },
  watch: {
      cameraId() {
          this.onCameraIdChanged();
      }
  },
  mounted() {
      const that = this;
      this.player = new ZJPlayer.PreviewPlayer({
        dom: this.$refs.player,
        mediaCenter: this.CNF('mediaCenter'),
        camera: {
          cameraId: this.cameraId,
          cameraName: this.cameraName,
          scaleMode: this.scaleMode,
          streamType: this.streamType,
          zipMethod: this.zipMethod,
          align: this.align
        }
      });
      this.player.on('clickStopButton', function() {
        that.noautoplay = true;
      });
      if (this.autoplay) {
        this.play();
      }
      else {
        this.stop();
      }
  },
  destroyed() {
      this.stop();
      this.player = null;
      if (this.$refs.player) {
        this.$refs.player.innerHTML = '';
      }
      if (this.fullscreenDiv) {
        document.body.removeChild(this.fullscreenDiv);
        this.fullscreenDiv = null;
      }
  },
  methods: {
      isPlaying() {
        return this.player.isPlaying();
      },
      play() {
        this.player.play({
          cameraId: this.cameraId,
          cameraName: this.cameraName,
          scaleMode: this.scaleMode,
          streamType: this.streamType,
          zipMethod: this.zipMethod,
          align: this.align
        });
      },
      stop() {
        this.noautoplay = true;
        this.player.stop();
      },
      resize(opts) {
        this.player.resize(opts);
      },
      onCameraIdChanged() {
        this.player.setCameraId(this.cameraId);
        this.player.setTitle(this.cameraName);
        if (this.player.isPlaying()) {
          this.play();
        }
        else if (this.autoplay && !this.noautoplay) {
          this.play();
        }
      },
      onDblClick() {
        if (this.fullscreenDiv) {
          this.fullscreenDiv.removeChild(this.$refs.player);
          this.$el.appendChild(this.$refs.player);
          document.body.removeChild(this.fullscreenDiv);
          this.fullscreenDiv = null;
          this.player.resize();
        }
        else {
          const div = document.createElement('div');
          div.className = 'zj-camera-player fullscreen is-preview';
          this.$el.removeChild(this.$refs.player);
          div.appendChild(this.$refs.player);
          document.body.appendChild(div);
          this.fullscreenDiv = div;
          this.player.resize();
        }
      }
  }
}
</script>
